import type { $Fetch } from 'ofetch';
import type { DocumentoEmissaoGateway } from '@/application/port/out/DocumentoEmissaoGateway';
import type { DocumentoEmitido, EmitirDocumentoCommand } from '@/domain/model/DocumentoEmitido';
import type { ApiResponse } from '@/infrastructure/http/types';
import { assertApiSuccess } from '@/infrastructure/http/assertApiSuccess';

/**
 * HTTP gateway pra emissão de documentos.
 * Authority: acadadmin:emissao:read|create.
 *
 * @since G.5.4
 */
export class HttpDocumentoEmissaoGateway implements DocumentoEmissaoGateway {
  constructor(private readonly client: $Fetch) {}

  async listByAluno(alunoId: string): Promise<DocumentoEmitido[]> {
    const res = await this.client<ApiResponse<DocumentoEmitido[]>>(
      `/api/v1/admin/documentos-emitidos/aluno/${encodeURIComponent(alunoId)}`,
      { method: 'GET' });
    assertApiSuccess(res);
    return res.data;
  }

  async get(id: string): Promise<DocumentoEmitido> {
    const res = await this.client<ApiResponse<DocumentoEmitido>>(
      `/api/v1/admin/documentos-emitidos/${encodeURIComponent(id)}`,
      { method: 'GET' });
    assertApiSuccess(res);
    return res.data;
  }

  async emitir(cmd: EmitirDocumentoCommand): Promise<DocumentoEmitido> {
    const res = await this.client<ApiResponse<DocumentoEmitido>>(
      '/api/v1/admin/documentos-emitidos/emitir', { method: 'POST', body: cmd });
    assertApiSuccess(res);
    return res.data;
  }
}
